import React from 'react';
import PropTypes from 'prop-types';
import styles from './article.module.css';

import { CanvasContext } from './Context';

export const Canvas = ({
	paddingLeft,
	paddingRight,
	children,
}) => {
	return (
		<div
			className={`${styles['canvas']} canvas`}
		>
			<CanvasContext.Provider
				value={{
					paddingLeft,
					paddingRight,
				}}
			>
				{children}
			</CanvasContext.Provider>
		</div>
	);
};

Canvas.propTypes = {
	color: PropTypes.string,
	backgroundColor: PropTypes.string,
	paddingLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	paddingRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	paddingBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	paddingTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]),
};

Canvas.defaultProps = {
	color: '#ffffff',
	backgroundColor: '#ffffff',
	paddingTop: 0,
	paddingBottom: 0,
	horizontalPadding: 0,
};
